/**
 * Constants for tire procedure fee options
 */

import { TOption } from "type";

export const TIRE_TYPE_OPTIONS = [
  { label: "夏タイヤ", value: "s" },
  { label: "冬タイヤ", value: "w" },
  { label: "オールシーズン", value: "a" },
] as TOption[];

export const PUNCTURE_COMPENSATION_OPTIONS = [
  { label: "なし", value: 0 },
  { label: "2本補償", value: 2 },
  { label: "4本補償", value: 4 },
] as TOption[];

export const PUNCTURE_COMPENSATION_WHEEL_OPTIONS = [
  { label: "する", value: 0 },
  { label: "4本補償", value: 4 },
] as TOption[];

export const CASHBACK_PERIOD_OPTIONS = [
  { label: "期間外", value: 1 },
  { label: "期間中", value: 2 },
] as TOption[];

export const ROUNDING_OPTIONS = Array.from({ length: 5 }, (_, i) => ({
  label: String(i),
  value: i,
})) as TOption[];

export const TIRE_NUMBER_OPTIONS = [1, 2, 4] as const;

export const MAX_TIRE_SELECTION = 5;

export const DEFAULT_TIRE_NUMBER = 4;
